import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

export class Gallery {

    constructor( target = '.fancybox-holder', options = {} ) {
        this.target = target;
    }

    init() {
        const gallery = Array.from( document.querySelectorAll( this.target ) );
        const galleryArray = [];

        gallery.forEach( ( image, i ) => {
            const imageURL = image.dataset.image;
            const thumbURL = image.dataset.thumb;
            const imageTitle = image.dataset.slug;

            galleryArray[i] = {
                src: imageURL,
                thumb: thumbURL,
                slug: imageTitle
            };
        });

        document.addEventListener('click', (e) => {
            this.click(e, galleryArray);
        });
    }

    click(e, galleryArray) {
        const target = e.target.closest('.c-image--gallery');

        if( target ) {
            Fancybox.show(galleryArray);
        }
    }

}